var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditTitleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 26,
    width: 26,
    height: 26,
    rx: 13,
    transform: "rotate(-90 0 26)",
    fill: "#39A2DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 17.9703C18.776 17.9703 19 18.201 19 18.4851C19 18.7693 18.776 18.9999 18.5 18.9999H13.6648C13.3888 18.9999 13.1648 18.7693 13.1648 18.4851C13.1648 18.201 13.3888 17.9703 13.6648 17.9703H18.5ZM15.4106 6.44865C15.444 6.47542 16.5593 7.36773 16.5593 7.36773C16.9646 7.61621 17.2812 8.0603 17.4012 8.58608C17.5206 9.10636 17.4339 9.64312 17.1559 10.0968C17.1541 10.0998 17.1522 10.1028 17.1458 10.1117L17.1408 10.1186C17.0956 10.1798 16.8995 10.4352 15.9095 11.7123C15.9003 11.729 15.8899 11.7447 15.8785 11.7599C15.8618 11.7824 15.8436 11.803 15.8242 11.8218C15.7567 11.9094 15.6854 12.0014 15.6104 12.0981L15.4584 12.294C15.1449 12.6983 14.773 13.1776 14.3318 13.7462L14.1054 14.038C13.2537 15.1357 12.1628 16.5411 10.7654 18.3411C10.4594 18.7337 10.0008 18.9622 9.5081 18.9684L7.08216 19H7.07549C6.84416 19 6.64283 18.8366 6.58884 18.604L6.04285 16.2215C5.93018 15.728 6.04218 15.2187 6.34951 14.8233L12.6294 6.73625C12.632 6.73351 12.634 6.73007 12.6367 6.72733C13.3253 5.87964 14.5706 5.75471 15.4106 6.44865ZM11.9292 9.28575L7.13016 15.4665C7.01616 15.6133 6.97416 15.8028 7.01616 15.9847L7.47015 17.9649L9.4961 17.9388C9.68876 17.9368 9.86676 17.8482 9.98475 17.6972C10.5924 16.9145 11.3561 15.9306 12.1413 14.919L12.4191 14.5611L12.6973 14.2025C13.4337 13.2537 14.1612 12.3162 14.7699 11.5315L11.9292 9.28575ZM13.4067 7.38421L12.5538 8.4813L15.3943 10.7264C15.941 10.0214 16.3007 9.55697 16.3339 9.5127C16.4433 9.33012 16.4859 9.07204 16.4286 8.82357C16.3699 8.56892 16.2159 8.3527 15.9939 8.21474C15.9466 8.18111 14.8233 7.28331 14.7886 7.25516C14.366 6.90648 13.7493 6.96688 13.4067 7.38421Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTitleIcon);
export default __webpack_public_path__ + "static/media/EditTitleIcon.107952cf2b575b93523b0eb570c492f3.svg";
export { ForwardRef as ReactComponent };